import Navbar from '../../../common/Navbar/Navbar';
import Layout from '../../../common/layouts/Layout';
import IRBSubmissionsTable from './Table/IRBSubmissionsTable';

const IRBSubmissionsContainer = () => {

    return (
        <Layout>
            <>
                <Navbar pageTitle="MIRB Submission" />
                <IRBSubmissionsTable />
            </>
        </Layout>
    )
}

export default IRBSubmissionsContainer;